import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ILookup } from '../interfaces/ILookup.interface';
import { UrlPrefix } from '../constants/url-prefix.constants';

@Injectable()
export class DomainService {

  constructor(private http: HttpClient) {}

  public getDomains(includeUrl: boolean = false): Observable<Array<ILookup>> {
    return this.http.get<Array<ILookup>>(`${UrlPrefix.OLD_SETUP_API_PREFIX}/lookups/domains?includeUrl=${includeUrl}`);
  }
}
